const SECONDS_IN_MINUTE = 60;
const MILLISECONDS_IN_SECOND = 1000;

export const formatDate = (value: string) => new Date(value).toLocaleDateString('en-US');

export const formatDateTime = (value: string) => new Date(value).toLocaleString('en-US');

export const convertUTCDateToLocalDate = (date: Date) =>
  new Date(date.getTime() - date.getTimezoneOffset() * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND);
